import { io } from 'socket.io-client';
import { eventBus } from 'services';

const { REACT_APP_URL_BROADCAST, NODE_ENV } = process.env;

const environment = {
  local: {
    ws: 'http://localhost:3335',
  },
  production: {
    ws: REACT_APP_URL_BROADCAST as string,
  },
};

const baseURL =
  NODE_ENV === 'development' ? environment.local : environment.production;

// const socket = io(baseURL.ws, {});

// socket.on('connect', () => {
//   const engine = socket.io.engine;
//   console.log('Socket engine:', engine.transport.name);
//   engine.once('upgrade', () => {
//     console.log('Socket engine upgraded:', engine.transport.name);
//   });
// });

// socket.on('logout', (data: any) => {
//   eventBus.dispatch<number>('logoutUserById', data?.userId);
// });
